import BaseRadioGroup from './RadioGroup';

// EXPORT
export const RadioGroup = BaseRadioGroup;
export type { RadioGroupProps } from './RadioGroup.interface';
